import { Device } from '@capacitor/device';

// Store platform info globally
let platformCache = null;
let isDetecting = false;
let detectPromise = null;

// Detect platform and cache it
const detectPlatform = async () => {
  if (platformCache) {
    return platformCache;
  }

  if (isDetecting) {
    return detectPromise;
  }

  isDetecting = true;
  detectPromise = (async () => {
    try {
      const device = await Device.getInfo();
      const id = await Device.getId();

      console.log("Capacitor Device Info:", device);
      console.log("Capacitor Device ID:", id);

      platformCache = {
        os: device.operatingSystem,
        model: device.model,
        uuid: id.identifier,
        platform: device.platform,
      };

      console.log("Platform Info Cached:", platformCache);
      return platformCache;
    } catch (error) {
      console.error("Error detecting platform:", error);
      // Fallback to web
      platformCache = {
        os: "web",
        model: "unknown",
        uuid: "web-uuid",
        platform: "web",
      };
      return platformCache;
    } finally {
      isDetecting = false;
    }
  })();

  return detectPromise;
};

// Get platform synchronously (returns null if not detected yet)
export const getPlatformSync = () => {
  return platformCache;
};

// Get platform async (always returns a value)
export const getPlatform = async () => {
  return await detectPlatform();
};

// Initialize platform detection on module load
detectPlatform();

export default getPlatformSync;

